import React, { useState, useEffect } from 'react';

import styled from 'styled-components';

import { Form, Radio, Tooltip, Input, Checkbox } from 'antd';

import { useAtomValue, useAtom, useSetAtom } from 'jotai';
import { useImmerAtom } from 'jotai-immer';
import { enableMapSet } from 'immer';

import * as Constants from '../../views/diagnosis/constants';
import EdemaOrAscites from './CancerEdemaOrAscites';
import CancerKindStringInput from './CancerKindStringInput';
import { useHandleEventValue } from './hooks';
import { cancerCategorySetAtom, cancerAnotherDiseaseSetAtom, cancerAtom, cancerCategorySetChangeAtom, cancerAnotherDiseaseSetChangeAtom, cancerEdemaOrAscitesAtom } from './atom';

export const ANOTHER_DISEASE = [
  { name: '간질환', value: 'liverDisease' },
  { name: '고혈압', value: 'hypertension' },
  { name: '고콜레스테롤혈증', value: 'Hypercholesterolemia' },
  { name: '고중성지방혈증', value: 'Hypertriglyceridemia' },
  { name: '골다공증', value: 'Osteoporosis' },
  { name: '당뇨병', value: 'diabetes' },
  { name: '기타', value: 'etc' },
  { name: '없음', value: 'none' }
];
enableMapSet();

export default function Cancer({ getFieldDecorator, radioButtonMessage, inputMessage, handleValueionClick, color, diseaseArray, handleValueionDiseaseClick }) {
  const [, setCancerData] = useImmerAtom(cancerAtom);
  const [, setCancerCategorySetChange] = useAtom(cancerCategorySetChangeAtom);
  const [, setCancerAnotherDiseaseSetChange] = useAtom(cancerAnotherDiseaseSetChangeAtom);
  const handleValue = useHandleEventValue({ setImmerState: setCancerData });
  const cancerCategorySet = useAtomValue(cancerCategorySetAtom);
  const anotherDiseaseSet = useAtomValue(cancerAnotherDiseaseSetAtom);
  const handleWeightChangeChangeValue = useSetAtom(cancerEdemaOrAscitesAtom);
  const handleMultipleChoice = fieldValue => e => {
    e.preventDefault();
    const targetData = e.currentTarget.value;
    if (fieldValue === 'cancerCategorySet') {
      setCancerCategorySetChange(targetData);
    } else {
      setCancerAnotherDiseaseSetChange(targetData);
    }
  };

  return (
    //
    <>
      <Form.Item>
        {getFieldDecorator('weightChange', {
          rules: [
            {
              required: true,
              message: radioButtonMessage
            }
          ]
        })(
          <CheckDiagnosisSection>
            <QueryTitle>
              아래 증상과 관련하여 <br /> 해당되는 사항을 선택해주세요
            </QueryTitle>
            <SubQueryTitle>최근 6개월 사이에 눈에 띄는 체중 변화가 있으신가요?</SubQueryTitle>
            <Radio.Group buttonStyle="solid">
              {Constants.YES_OR_NO.map(item => {
                const { name, value } = item;
                return (
                  <SelectBox key={value} onClick={() => handleWeightChangeChangeValue(value)} value={value}>
                    {name}
                  </SelectBox>
                );
              })}
            </Radio.Group>
          </CheckDiagnosisSection>
        )}
      </Form.Item>

      <EdemaOrAscites getFieldDecorator={getFieldDecorator} radioButtonMessage={radioButtonMessage} handleValueionClick={handleValueionClick} />

      <Form.Item>
        {getFieldDecorator('anorexia', {
          //   initialValue: '',
          rules: [
            {
              required: true,
              message: radioButtonMessage
            }
          ]
        })(
          <CheckDiagnosisSection>
            <SubQueryTitle>
              <b>식욕부진</b>이 있으신가요?
            </SubQueryTitle>
            <Radio.Group buttonStyle="solid">
              {Constants.YES_OR_NO.map(item => {
                const { name, value } = item;
                return (
                  <SelectBox key={value} onClick={handleValue('anorexia')} value={value}>
                    {name}
                  </SelectBox>
                );
              })}
            </Radio.Group>
          </CheckDiagnosisSection>
        )}
      </Form.Item>

      <Form.Item>
        {getFieldDecorator('cancerCategory', {
          rules: [
            {
              required: false,
              message: radioButtonMessage
            }
          ]
        })(
          <CheckDiagnosisSection>
            <QueryTitle>진단받은 질환을 선택해 주세요</QueryTitle>
            {/* <SubQueryTitle>어떠한 암을 진단 받으셨나요?</SubQueryTitle> */}
            <Checkbox.Group style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '1rem' }}>
              {Constants.CANCER_CATEGORY?.map(item => {
                const { name, value } = item;
                const isSelected = cancerCategorySet.has(value);
                return (
                  <AnotherDiseaseButton key={value} onClick={handleMultipleChoice('cancerCategorySet')} value={value} isSelected={isSelected} color={color}>
                    {name}
                  </AnotherDiseaseButton>
                );
              })}
            </Checkbox.Group>
          </CheckDiagnosisSection>
        )}
      </Form.Item>

      <CancerKindStringInput getFieldDecorator={getFieldDecorator} inputMessage={inputMessage} />

      <Form.Item>
        {getFieldDecorator('anotherDisease', {
          rules: [
            {
              message: radioButtonMessage
            }
          ]
        })(
          <CheckDiagnosisSection>
            <QueryTitle />
            <SubQueryTitle>
              암 질환 외 관리가 필요한 다른 질환이 있으신가요?
              <br />
              (중복 선택 가능)
            </SubQueryTitle>
            <Checkbox.Group style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '1rem' }}>
              {ANOTHER_DISEASE.map(item => {
                const { name, value } = item;
                const isSelected = anotherDiseaseSet.has(value);
                return (
                  <AnotherDiseaseButton key={value} onClick={handleMultipleChoice('anotherDiseaseSet')} value={value} isSelected={isSelected} color={color}>
                    {name}
                  </AnotherDiseaseButton>
                );
              })}
            </Checkbox.Group>
          </CheckDiagnosisSection>
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator('albumin', {
          //   initialValue: diagnosis.bornYear.toString(),
          rules: [
            {
              required: false,
              message: inputMessage
            },
            {
              max: 3,
              message: '3자리 숫자를 입력해주세요. (예:3.5)'
            }
          ]
        })(
          <>
            <BornYearSection>
              <QueryTitle>
                정확한 영양진단을 위해
                <br />
                해당 수치를 입력해주세요
              </QueryTitle>
              <>수치를 입력하시면, 더 자세한 영양상담이 가능합니다</>
              <SubQueryTitle>
                <b>알부민</b> 수치
              </SubQueryTitle>
              <InputBox name="albumin" onChange={handleValue('cancer', 'albumin')} placeholder="예 : 3.5" suffix="g/dL" maxLength={3} type="number" />
            </BornYearSection>
            <Tooltip placement="bottom" title="최근 한 달 이내의 영양 상태를 반영하는 중요한 지표">
              <span style={{ color }}>알부민 (Albumin)?</span>
            </Tooltip>
          </>
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator('hemoglobin', {
          //   initialValue: diagnosis.bornYear.toString(),
          rules: [
            {
              required: false,
              message: inputMessage
            },
            {
              max: 4,
              message: '4자리 숫자를 입력해주세요. (예:13.5)'
            }
          ]
        })(
          <>
            <BornYearSection>
              <SubQueryTitle>
                <b>헤모글로빈 (Hb)</b> 수치
              </SubQueryTitle>
              <InputBox name="hemoglobin" onChange={handleValue('hemoglobin')} placeholder="예 : 13.5" suffix="g/dL" maxLength={4} type="number" />
            </BornYearSection>
            <Tooltip placement="bottom" title="빈혈의 지표로 영양 상태 반영 지표">
              <span style={{ color }}>헤모글로빈 (Hemoglobin)?</span>
            </Tooltip>
          </>
        )}
      </Form.Item>
    </>
  );
}

const RelayionTypeSection = styled.div`
  .ant-radio-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    font-size: 1.8rem;
    ${props => props.theme.device.md} {
      font-size: 2.4rem;
    }
  }
`;

const CheckDiagnosisSection = styled(RelayionTypeSection)``;

const QueryTitle = styled.div`
  word-break: keep-all;
  font-size: 2.1rem;
  font-weight: 700;
  color: #323232;
  margin-bottom: 2rem;
  margin-top: 5rem;
  ${props => props.theme.device.md} {
    margin-top: 10rem;
    font-size: 2.9rem;
  }
`;
const SubQueryTitle = styled.div`
  word-break: keep-all;
  font-size: 1.5rem;
  font-weight: 400;
  color: #323232;
  margin-bottom: ${props => (props.isText ? '0' : '2rem')};

  ${props => props.theme.device.md} {
    font-size: 2rem;
  }
`;
const SelectBox = styled(Radio.Button)`
  height: 6rem;
  word-break: keep-all;
  margin: 0.5rem 0;
  width: calc(50% - 1.6rem);
  line-height: ${props => (props.lineHight ? '4rem' : '6rem')};
  span {
    font-size: 1.6rem;
  }
  ${props => props.theme.device.md} {
    height: 7.2rem;
    line-height: ${props => (props.lineHight ? '6.5rem' : '7.2rem')};
    span {
      font-size: 2.4rem;
      word-break: keep-all;
    }
  }
`;
const BornYearSection = styled(RelayionTypeSection)``;

const InputBox = styled(Input)`
  width: 60%;
  height: 6rem;
  line-height: 6rem;
  font-size: 1.8rem;
  margin-bottom: 1rem;
  input::placeholder {
    font-size: 1.8rem;
  }
  ${props => props.theme.device.md} {
    font-size: 2.4rem;
    height: 7.2rem;
    line-height: 7.2rem;
    input::placeholder {
      font-size: 2.4rem;
    }
  }
`;
const AnotherDiseaseButton = styled.button`
  border: 1px solid #333;
  background-color: ${props => (props.isSelected ? '#ededed' : 'white')};
  color: ${props => (props.isSelected ? props.color : '#000000a6')};
  cursor: pointer;
  border: 1px solid #d9d9d9;
  width: calc(50% - 1.6rem);
  height: 6rem;
  word-break: keep-all;
  font-size: 1.6rem;
  ${props => props.theme.device.md} {
    height: 7.2rem;
    font-size: 2.4rem;
    word-break: keep-all;
  }
`;
